/**
* 基础菜单 订单满减管理
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <!-- <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>营销管理</el-breadcrumb-item>
        <el-breadcrumb-item>订单满赠管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-select v-model="formInline.status" placeholder="有效类型" clearable>
          <el-option label="无效" value="0"></el-option>
          <el-option label="有效" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="primary" @click="adddgive" class="add-button">新增</el-button>
        <el-button size="small" type="primary" @click="editgive" class="edit-button">修改</el-button>
        <el-button size="small" type="danger" @click="delgive">删除</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 90%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="full_name" label="满赠名称" min-width="220" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <div style="white-space: pre;" class="over_text_1">{{scope.row.full_name}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="full_money" label="满赠订单金额" width="120" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <div v-if="scope.row.full_money||scope.row.full_money==0">￥{{scope.row.full_money}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="give_max_money" label="赠品价值" width="120" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <div v-if="scope.row.give_max_money||scope.row.give_max_money==0">￥{{scope.row.give_max_money}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="create_name" label="创建人" width="180" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="135">
        </el-table-column>
        <el-table-column prop="end_time" label="结束时间" width="135">
        </el-table-column>
        <el-table-column prop="status" label="有效状态" width="76">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @change="changeStatus(scope.row.id,scope.row.status)"
              active-color="#409EFF">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column align="left" label="操作" width="174">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="detail(scope.row.id)">
              赠品详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="giveDialogVisible"
               width="30%"
               :before-close="handleClose"
               center>
      <el-form label-width="155px" :model="giveForm" :rules="rules" ref="giveForm" class="giveForm">
        <el-form-item label="满赠名称" prop="full_name" class="relative">
          <el-input size="small" v-model="giveForm.full_name" auto-complete="off" clearable maxlength="100"
                    placeholder="请输入满赠名称"></el-input>
        </el-form-item>
        <el-form-item label="满赠订单金额" prop="full_money" class="relative">
          <el-input size="small" v-model="giveForm.full_money" auto-complete="off" clearable maxlength="8"
                    placeholder="请输入满赠订单金额"></el-input>
        </el-form-item>
        <el-form-item label="赠品价值" prop="give_max_money" class="relative">
          <el-input size="small" v-model="giveForm.give_max_money" auto-complete="off" clearable maxlength="8"
                    placeholder="请输入赠品价值"></el-input>
        </el-form-item>
        <el-form-item label="结束时间" prop="end_time">
          <template>
            <div class="block">
              <el-date-picker
                v-model="giveForm.end_time"
                type="datetime"
                placeholder="请选择结束时间">
              </el-date-picker>
            </div>
          </template>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="resetForm('giveForm')">重 置</el-button>
            <el-button type="primary" @click="saveGive('giveForm')">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="赠品详情"
               :visible.sync="detailDialogVisible"
               width="80%"
               center>
      <el-form :inline="true" :model="detailformInline" class="user-search">
        <el-form-item label="">
          <el-input size="small" v-model="detailformInline.sale_name" placeholder="请输入销售名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input size="small" v-model="detailformInline.product_name" placeholder="请输入商品名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input size="small" v-model="detailformInline.product_code" placeholder="请输入商品编码" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="searchDetail">查询</el-button>
          <el-button size="small" type="primary" @click="adddgiveDetail" class="add-button">新增</el-button>
          <el-button size="small" type="primary" @click="editgiveDetail" class="edit-button">修改</el-button>
          <el-button size="small" type="danger" @click="delgiveDetail">删除</el-button>
        </el-form-item>
      </el-form>
      <!--列表-->
      <div style="height: 530px;overflow-y: auto">
        <el-table size="small" :data="detailListData" highlight-current-row v-loading="loading" border
                  @cell-dblclick="detailcellDbClick" @selection-change="handleDetailSelectionChange"
                  :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                  element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column align="center" type="selection" width="60">
          </el-table-column>
          <el-table-column
            label="序号"
            width="60">
            <template slot-scope="scope">
              {{detailpageparm.pageSize * (detailpageparm.currentPage - 1) + (scope.$index + 1)}}
            </template>
          </el-table-column>
          <el-table-column prop="sale_name" label="销售名称" min-width="220" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <div style="white-space: pre;" class="over_text_1">{{scope.row.sale_name}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="product_name" label="商品名称" width="220" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <div style="white-space: pre;" class="over_text_1">{{scope.row.product_name}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="product_code" label="商品编码" width="150" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="sale_price" label="销售价" width="90">
            <template slot-scope="scope">
              <div>￥{{scope.row.sale_price}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="available_stock" label="库存数量" width="100" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="available_stock" label="是否为默认赠品" width="120">
            <template slot-scope="scope">
              <div>{{scope.row.is_default?'是':'否'}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="有效状态" width="76">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                :active-value="1"
                :inactive-value="0"
                @change="changeDetailStatus(scope.row.id,scope.row.status)"
                active-color="#409EFF">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="create_name" label="创建人" width="180" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="135">
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="detailpageparm" @callFather="detailCallFather"></Pagination>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogDetailTitle"
               :visible.sync="giveDetailDialogVisible"
               width="30%"
               :before-close="handleDetailClose"
               center>
      <el-form label-width="155px" :model="giveDetailForm" :rules="giveDetailrules" ref="giveDetailForm"
               class="giveDetailForm">
        <el-form-item label="赠品名称" prop="sale_id" class="relative">
          <el-select v-model="giveDetailForm.sale_id" filterable placeholder="请选择赠品名称" clearable
                     remote :filter-method="remoteMethod" class="productInterval" :popper-append-to-body="false"
                     @focus="focusProductName()" @change="changeProductName()" @clear="clear()">
            <el-option :title="item.sale_name"
                       v-for="item in productData"
                       :key="item.sale_id"
                       :label="item.sale_name"
                       :value="item.sale_id">
            </el-option>
            <div class="pagination-absolute">
              <el-pagination :small="small" style="height: 30px;margin-top: 8px"
                             @size-change="productHandleSizeChange"
                             @current-change="productHandleCurrentChange"
                             :current-page.sync="productCurrentPage"
                             :page-size="productPagesize"
                             layout="total, prev, pager, next"
                             :total="productTotalSize">
              </el-pagination>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="有效状态" prop="status" class="relative">
          <el-select v-model="giveDetailForm.status" placeholder="请选择有效状态" clearable>
            <el-option v-for="status in validStatus" :key="status.value" :label="status.name"
                       :value="status.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否默认赠品" prop="is_default" class="relative">
          <el-select v-model="giveDetailForm.is_default" placeholder="请选择是否默认赠品" clearable>
            <el-option v-for="defaults in is_default" :key="defaults.value" :label="defaults.name"
                       :value="defaults.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="resetDetailForm('giveDetailForm')">重 置</el-button>
            <el-button type="primary" @click="saveDetailGive('giveDetailForm')">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    giveUpdate,
    giveList,
    giveAdd,
    giveDelete,
    giveDisabled,
    giveEnabled,
    giveDetailUpdate,
    giveDetailList,
    giveDetailAdd,
    giveDetailDelete,
    giveDetailEnabled,
    giveDetailDisabled, productSaleList,
    giveItemDetail
  } from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {timestampToTime} from '../../utils/util'

  export default {
    name: 'gift',
    data: () => {
      var validateNum = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入满赠订单金额'));
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('请输入正整数'));
        } else {
          return callback();
        }
      };
      var validateSalePrice = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入赠品价值'));
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('输入长度过长或格式不正确'));
        } else {
          return callback();
        }
      };
      return {
        loading: false, //是显示加载
        giveDialogVisible: false,  // 弹窗
        detailDialogVisible: false,  // 弹窗
        giveDetailDialogVisible: false,  // 弹窗
        dialogTitle: '',  // 标题
        dialogDetailTitle: '',
        selectTableData: [],
        productId: '',
        formInline: {
          page: 1,
          rows: 10,
          status: '',
          brand_name: ''
        },
        detailformInline: {
          page: 1,
          rows: 10,
          order_full_give_id: '',
          sale_name: "",
          product_name: "",
          product_code: ""
        },
        rules: {
          full_name: [{required: true, message: '请输入满赠名称', trigger: 'blur'}],
          full_money: [{required: true, validator: validateNum, trigger: 'blur'}],
          give_max_money: [{required: true, validator: validateSalePrice, trigger: 'blur'}],
          end_time: [{required: true, message: '请选择结束时间', trigger: 'blur'}],
        },
        giveDetailrules: {
          sale_id: [{required: true, message: '请输入赠品名称', trigger: 'blur'}],
          status: [{required: true, message: '请选择有效状态', trigger: 'change'}],
          is_default: [{required: true, message: '请选择是否默认赠品', trigger: 'change'}],
        },
        giveForm: {
          id: '',
          full_name: '',
          full_money: '',
          give_max_money: '',
          end_time: '',
        },
        giveDetailForm: {
          id: '',
          order_full_give_id: '',
          status: '',
          sale_id: '',
          is_default: '',
        },
        order_full_give_id: '',
        listData: [], //用户数据
        detailListData: [],
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        detailpageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        sale_id: '',
        status: [{
          name: '是',
          value: 1
        }, {
          name: '否',
          value: 0
        }],
        validStatus: [{
          name: '有效',
          value: 1
        }, {
          name: '无效',
          value: 0
        }],
        is_default: [{
          name: '是',
          value: 1
        }, {
          name: '否',
          value: 0
        }],
        selectedsaleName: '',
        saleName: '',
        selectDetailTableData: [],
        productData: [],
        productCurrentPage: 1,
        productPagesize: 10,
        productTotalSize: 0,
        small: true,
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
    methods: {
      clear() {
        this.getProduct()
        this.productCurrentPage = 1
        this.saleName = ''
      },
      productHandleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.productPagesize = val;
        this.getProduct(this.saleName)
      },
      productHandleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.productCurrentPage = val;
        this.getProduct(this.saleName)
      },
      focusProductName() {
        if (!this.selectedsaleName) {
          this.saleName = ''
          this.getProduct('')
        }
      },
      changeProductName() {
        this.productCurrentPage = 1;
        this.productData.forEach((item) => {
          if (item.sale_id == this.giveDetailForm.sale_id) {
            this.selectedsaleName = item.sale_name;
            this.getProduct(item.sale_name)
          }
        })
      },
      getProduct(saleName) {
        let parameter = {
          page: this.productCurrentPage,
          rows: 10,
          keyword: saleName,
          put_away_status: '75',
        };
        productSaleList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (!res.rows.length) {
                this.selectedsaleName = ''
              }
              this.productData = res.rows;
              this.productTotalSize = res.total;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      remoteMethod(val) {
        this.productCurrentPage = 1
        this.saleName = val;
        this.getProduct(val)
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      // 无效状态
      changeStatus(id, status) {
        if (!status) {
          giveDisabled(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: '已将状态设置为无效!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        } else {
          giveEnabled(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '已将状态设置为有效!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }
      },
      // 无效状态
      changeDetailStatus(id, status) {
        if (!status) {
          giveDetailDisabled(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: '已将状态设置为无效!'
                });
                this.getDetaildata(this.detailformInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        } else {
          giveDetailEnabled(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '已将状态设置为有效!'
                });
                this.getDetaildata(this.detailformInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }
      },
      // 新增按钮
      adddgive() {
        this.giveDialogVisible = true;
        this.dialogTitle = '新增订单满赠';
        this.giveForm = {
          id: '',
          full_name: '',
          full_money: '',
          give_max_money: '',
          end_time: '',
        };
      },
      // 修改按钮
      editgive() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.productId = this.selectTableData[0].id;
        this.giveDialogVisible = true;
        this.dialogTitle = '修改订单满赠';
        this.giveForm.full_name = this.selectTableData[0].full_name;
        this.giveForm.full_money = this.selectTableData[0].full_money;
        this.giveForm.give_max_money = this.selectTableData[0].give_max_money;
        this.giveForm.end_time = this.selectTableData[0].end_time;
      },
      adddgiveDetail() {
        this.giveDetailDialogVisible = true;
        this.dialogDetailTitle = '新增订单赠品';
        this.selectedsaleName = '';
        this.giveDetailForm = {
          status: '',
          sale_id: '',
          is_default: '',
        };
      },
      editgiveDetail() {
        this.dialogDetailTitle = '修改订单赠品';
        if (this.selectDetailTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectDetailTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.getProduct(this.selectDetailTableData[0].sale_name)
        // this.giveDetailForm.order_full_give_id = this.selectDetailTableData[0].order_full_give_id;
        // this.giveDetailForm.status = this.selectDetailTableData[0].status;
        // this.giveDetailForm.sale_id = this.selectDetailTableData[0].sale_id;
        // this.giveDetailForm.is_default = this.selectDetailTableData[0].is_default;
        // this.giveDetailForm.id = this.selectDetailTableData[0].id;

        giveItemDetail(this.selectDetailTableData[0].id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.giveDetailDialogVisible = true;
              this.selectedsaleName = this.selectDetailTableData[0].sale_name
              this.giveDetailForm = res.content
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 删除按钮
      delgive() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        const title = '是否删除订单满赠？';
        this.$confirm(title, '删除订单满赠', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          giveDelete(this.selectTableData[0].id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      delgiveDetail() {
        if (this.selectDetailTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectDetailTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        const title = '是否删除订单赠品？';
        this.$confirm(title, '删除订单赠品', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          giveDetailDelete(this.selectDetailTableData[0].id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getDetaildata(this.detailformInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      resetDetailForm(formName) {
        this.$refs[formName].resetFields();
      },
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        giveList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 获取详情列表
      getDetaildata(parameter) {
        this.loading = true
        giveDetailList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.detailListData = res.content.rows
              // 分页赋值
              this.detailpageparm.currentPage = this.detailformInline.page
              this.detailpageparm.pageSize = this.detailformInline.rows
              this.detailpageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      detailCallFather(parm) {
        this.detailformInline.page = parm.currentPage
        this.detailformInline.rows = parm.pageSize
        this.getDetaildata(this.detailformInline)
      },
      // 新增订单满赠保存
      saveGive(formName) {
        if (this.giveForm.end_time) {
          this.giveForm.end_time = timestampToTime(this.giveForm.end_time)
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            if (this.dialogTitle == '新增订单满赠') {
              giveAdd(this.giveForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功新增订单满赠'
                    });
                    this.giveDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.loading = false
                  this.$message.error('网络错误,请稍后再试!')
                })
            } else {
              this.giveForm.id = this.productId;
              this.loading = true;
              giveUpdate(this.giveForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功修改订单满赠'
                    });
                    this.giveDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.loading = false;
                  this.$message.error('网络错误,请稍后再试!')
                })
            }
          } else {
            console.log('error submit!!');
          }
        });
      },
      // 搜索事件
      search() {
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
      searchDetail() {
        this.detailformInline.page = 1;
        this.getDetaildata(this.detailformInline)
      },
      handleRemove(file) {
        console.log(file);
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      handleDetailSelectionChange(val) {
        this.selectDetailTableData = val
      },
      handleClose() {
        this.$refs["giveForm"].resetFields();
        this.giveDialogVisible = false;
      },
      handleDetailClose() {
        this.$refs["giveDetailForm"].resetFields();
        this.giveDetailDialogVisible = false;
      },
      detail(id) {
        this.detailDialogVisible = true;
        this.order_full_give_id = id;
        this.detailformInline.order_full_give_id = id
        this.getDetaildata(this.detailformInline)
      },
      // 新增订单赠品
      saveDetailGive(formName) {
        this.giveDetailForm.order_full_give_id = this.order_full_give_id;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            if (this.dialogDetailTitle == '新增订单赠品') {
              giveDetailAdd(this.giveDetailForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功新增订单赠品'
                    });
                    this.giveDetailDialogVisible = false;
                    this.getDetaildata(this.detailformInline)
                  }
                })
                .catch(err => {
                  this.loading = false
                  this.$message.error('网络错误,请稍后再试!')
                })
            } else {
              this.giveForm.id = this.productId;
              this.loading = true;
              giveDetailUpdate(this.giveDetailForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功修改新增订单赠品'
                    });
                    this.giveDetailDialogVisible = false;
                    this.getDetaildata(this.detailformInline)
                  }
                })
                .catch(err => {
                  this.loading = false;
                  this.$message.error('网络错误,请稍后再试!')
                })
            }
          } else {
            console.log('error submit!!');
          }
        });
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.brand_name == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      },
      detailcellDbClick(row, column, cell, event) {
        if (row.sale_name == cell.innerText || row.product_name == cell.innerText || row.product_code == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .giveForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .giveForm .el-input {
    width: 320px;
  }

  /deep/ .giveForm .el-input--small {
    width: 320px;
  }

  /deep/ .giveDetailForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .giveDetailForm .el-input {
    width: 320px;
  }

  /deep/ .giveDetailForm .el-input--small {
    width: 320px;
  }

  /deep/ .giveDetailForm .el-select-dropdown__item {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .giveDetailForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

  /deep/ .giveForm .el-form-item__label {
    position: relative;
    padding: 0 22px 0 0 !important;
  }

  /deep/ .giveForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

  /deep/ .giveForm .el-select-dropdown__item {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .el-message-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  .add-button {
    background: #53B03C;
    border-color: #53B03C;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

  .pagination-absolute {
    position: absolute;
    bottom: 0;
    background: #fff;
    width: 95%;
    padding-left: 20px;
    height: 40px;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }


</style>





// WEBPACK FOOTER //
// src/views/Marketing/orderFullGiftManage.vue